import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { isOutOfStock } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import removeCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import translate from "@insite/client-framework/Translate";
import { ProductSettingsModel, ProductSubscriptionDto, PromotionModel } from "@insite/client-framework/Types/ApiModels";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import ProductAvailability, { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBinNumbers from "@insite/content-library/Components/ProductBinNumbers";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDeliveryScheduleButton from "@insite/content-library/Components/ProductDeliveryScheduleButton";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import CartLineNotes, { CartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes";
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import CartLines, { CartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import XCircle from "@insite/mobius/Icons/XCircle";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import CartAlternatePartNumber, { CartPartNumberStyles } from "@tJohnstonCompanies/Widgets/CartAlternatePartNumber";
import CartCostCode, { CartCostCodeStyles } from "@tJohnstonCompanies/Widgets/CartCostCode";
import CartLineAccountNumber, { CartAccountNumberStyles } from "@tJohnstonCompanies/Widgets/CartLineAccountNumber";
import CartLineComment, { CartCommentStyles } from "@tJohnstonCompanies/Widgets/CartLineComment";
import CartUnitsNotes, { CartUnitsNotesStyles } from "@tJohnstonCompanies/Widgets/CartUnitNotes";
import React, { FC, useContext, useEffect, useState } from "react";
import { connect, HandleThunkActionCreator, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    cart: Cart;
    promotions: PromotionModel[];
    productSettings: ProductSettingsModel;
    showInventoryAvailability?: boolean;
    showLineNotes?: boolean;
    showImage?: boolean;
    showProductTitle?: boolean;
    showBrand?: boolean;
    showPerUnitPrice?: boolean;
    showPriceLabel?: boolean;
    showAddToList?: boolean;
    showProductNumber?: boolean;
    updateCartLine: HandleThunkActionCreator<typeof updateCartLine>;
    removeCartLine: HandleThunkActionCreator<typeof removeCartLine>;
    showRemoveAction?: boolean;
    hideAddToList?: boolean;
    showInvalidPriceMessage?: boolean;
    extendedStyles?: CartLineCardExpandedStyles;
    showVmiBinDetails?: boolean;
    // location: number;
    // setLocation: (arg: number) => void;
}

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    showPricing: state.context.showPricing,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

type Props = OwnProps &
    HasCartLineContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface CartLineCardExpandedStyles {
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    cartLineInfoGridItem?: GridItemProps;
    cartLineInfoContainer?: GridContainerProps;
    productInfoGridItem?: GridItemProps;
    productInfoContainer?: GridContainerProps;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productBrand?: ProductBrandStyles;
    productDescriptionGridItem?: GridItemProps;
    productDescription?: ProductDescriptionStyles;
    configurationGridItem?: GridItemProps;
    configurationOptionText?: TypographyProps;
    productPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    quantityWithPriceGridItem?: GridItemProps;
    quantityAndExtendedUnitNetPriceContainer?: GridContainerProps;
    quantity?: CartLineQuantityStyles;
    extendedUnitNetPriceGridItem?: GridItemProps;
    NetPriceGridItem?: GridItemProps;
    UnitNetPriceGridItem?: GridItemProps;
    UnitNetPriceInputGrid?: GridItemProps;
    CartCostCodeGridItem?: GridItemProps;
    extendedUnitNetPriceText?: TypographyProps;
    cartLineErrorMessageGridItem?: GridItemProps;
    cartLineErrorMessageText?: TypographyProps;
    productPriceAndAvailabilityGridItem?: GridItemProps;
    addToList?: GridItemProps;
    quantityAndExtendedUnitNetPriceGridItem?: GridItemProps;
    quantityGridItem?: GridItemProps;

    availProductprice?: GridItemProps;
    qty?: GridItemProps;
    CartField?: GridItemProps;
    unitNotesHeading?: GridItemProps;

    productPrice?: ProductPriceStyles;
    cartCostCode?: CartCostCodeStyles;
    promotionNameText?: TypographyProps;
    productAvailability?: ProductAvailabilityStyles;
    addToListLinkWIthSalesrep?: LinkPresentationProps;
    addToListLinkWithoutSalesrep?: LinkPresentationProps;
    toggleLink?: LinkPresentationProps;
    cartLineNotesGridItem?: GridItemProps;
    cartLineNotesAndCommentLinkGridItem?: GridItemProps;
    LineNotesAndCommentGridItem?: GridItemProps;
    bufferGrid?: GridItemProps;
    cartLineNotes?: CartLineNotesStyles;
    removeCartLineGridItem?: GridItemProps;
    removeCartLineIcon?: IconPresentationProps;
    binInformationsGridItem?: GridItemProps;
    productBinNumbers?: ProductPartNumbersStyles;
    CartUnitsNotes?: CartUnitsNotesStyles;
    CartLineComment?: CartCommentStyles;
    secondaryButton?: ButtonPresentationProps;
    updateButton?: ButtonPresentationProps;
    borderBottom?: CartLinesStyles;
    CartLineAccountNumber?: CartAccountNumberStyles;
    costCodeGridItem?: GridItemProps;
    updateButtonGridItem?: GridItemProps;
    CartPartNumber?: CartPartNumberStyles;
    deliveryScheduleButton?: ButtonPresentationProps;
    DiscontinuedGridItem?: GridItemProps;
    contactUs?: InjectableCss;
    discontinuedMsg?: InjectableCss;
    discontinuedWrapper?: InjectableCss;
}

export const cartLineCardExpandedStyles: CartLineCardExpandedStyles = {
    borderBottom: {
        headerWrapper: {
            css: css`
                //   border-bottom:none;
                border-bottom: none !important;
            `,
        },
    },
    container: {
        gap: 20,
        css: css`
            border: 1px solid ${getColor("common.border")};
            padding: 1rem 0;
            background-color: #fff;
            padding: 10px;
            margin-bottom: 10px;
            border-radius: 7px;
            // color: #a81010;
            > div[class^="GridOffset"] {
                box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
                > div[class^="GridItemStyle"] {
                    > div[class^="GridWrapper"] {
                        > div > div[class^="griditemstyle"]:last-child {
                            // max-width: 100%;
                            // flex-basis: 100%;
                            //padding: 0;
                            > div[class^="GridItemStyle"] {
                                // max-width: 18%;
                                // max-width: 25%;
                                // padding: 0;
                            }
                            > div[class^="griditemstyle"]:first-child {
                                // max-width: 18%;
                            }
                        }
                    }
                }
                > div[class^="griditemstyle"]:first-child {
                    display: flex;
                    align-items: center;
                    background-color: #ccc;
                    // justify-content: center;
                    padding: 0 25px;
                    border-radius: 7px 0px 0px 7px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    > a {
                                        // border: 5px solid black;
                                        justify-content: center;
                                    }
                                    border-radius: 7px 7px 0px 0px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    productImageGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    null,
                ])}
        `,
    },
    cartLineInfoGridItem: { width: [12, 12, 12, 8, 8] },
    cartLineInfoContainer: { gap: 20 },
    productInfoGridItem: { width: [6, 6, 6, 7, 7] },
    productInfoContainer: { gap: 12 },
    productBrandAndDescriptionGridItem: {
        css: css`
            flex-direction: column;
            // border: 5px solid black;
            > a:last-child {
                font-size: 18px;
                font-weight: 600;
                > span {
                    color: #a21010;
                }
            }
        `,
        width: 12,
    },
    productDescriptionGridItem: {
        width: 12,
    },
    configurationGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    productPartNumbersGridItem: { width: 12, css: css`` },
    quantityAndExtendedUnitNetPriceGridItem: { width: 9 },
    quantityGridItem: {
        width: 12,
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    UnitNetPriceGridItem: {
        width: 12,
        css: css`
            padding: 0;
            padding: 10px 0 0 0;
            display: flex;
            align-items: center;
            div[class^="FormInputWrapper"] {
                input {
                    border-radius: 0px 7px 7px 0px;
                    height: 33px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    height: 25px !important;
                                `,
                                null,
                                css`
                                    height: 28px;
                                `,
                                null,
                            ],
                            "max",
                        )}
                    background: #fff;
                }
            }
        `,
    },
    UnitNetPriceInputGrid: {
        width: 5,
        css: css`
            padding: 0;
            input {
                border-radius: 0 7px 7px 0;
            }
        `,
    },
    deliveryScheduleButton: {
        css: css`
            margin-top: 20px;
            margin-left: 30px;
        `,
    },
    CartCostCodeGridItem: {
        width: 12,
        css: css`
            width: 100%;
            padding: 10px 0 0 0;
        `,
    },

    extendedUnitNetPriceGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
            align-items: flex-end;
        `,
    },
    extendedUnitNetPriceText: {
        weight: "bold",
        css: css`
            margin-bottom: 10px;
        `,
    },
    cartLineErrorMessageGridItem: { width: 12 },
    cartLineErrorMessageText: { color: "danger" },
    productPriceAndAvailabilityGridItem: {
        width: [6, 6, 6, 5, 5],
        css: css`
            flex-direction: column;
        `,
    },
    addToList: {
        width: [12, 12, 12, 3, 6],
        css: css`
            flex-direction: column;
        `,
    },
    bufferGrid: { width: [12, 12, 12, 4, 2] },
    // quantityWithPriceGridItem : {
    //     width: [12, 12, 12, 3, 3],
    //     css: css ``,
    // },
    qty: {
        width: [3, 3, 3, 2, 2],
        css: css`
            flex-direction: column;
            background: #ccc;
            padding: 5px 0px 6px 6px !important;
            border-radius: 7px 0 0 7px;
            span {
                font-weight: 700;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                font-size: 11px;
                                padding: 1px 0 0 0;
                            `,

                            null,
                        ],
                        "max",
                    )}
            }
        `,
    },
    CartField: {
        width: [7, 7, 7, 7, 4],
        css: css`
            padding-left: 0;
            div[class^="FormFieldStyle"] {
                label {
                    display: none;
                }
                > div[class^="FormInputWrapper"] {
                    margin-top: 0;
                    input {
                        border-radius: 0 7px 7px 0;
                        height: 33px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    null,
                                    css`
                                        height: 28px;
                                    `,

                                    null,
                                ],
                                "max",
                            )}

                        width: 75%;
                        background: #fff;
                    }
                    /* Chrome, Safari, Edge, Opera */
                    input::-webkit-outer-spin-button,
                    input::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    /* Firefox */
                    input[type="number"] {
                        -moz-appearance: textfield;
                    }
                }
            }
        `,
    },
    unitNotesHeading: {
        width: [6, 6, 6, 6, 5],
        css: css`
            background-color: #ccc;
            justify-content: center;
            border-radius: 7px 0px 0px 7px;
            // padding: 6px;
            padding: 5px 0 6px 6px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 5px !important;
                        `,
                        null,
                        css`
                            padding: 6px;
                        `,

                        null,
                    ],
                    "max",
                )}
            span {
                font-weight: 700;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: 10px !important;
                            `,
                            null,
                            css`
                                font-size: 11px;
                            `,

                            null,
                        ],
                        "max",
                    )}
            }
        `,
    },
    availProductprice: {
        width: [12, 12, 12, 2, 3],
        css: css`
            flex-direction: column;
        `,
    },
    addToListLinkWIthSalesrep: {
        css: css`
            padding: 6px;
            margin-top: 0px;
        `,
    },
    addToListLinkWithoutSalesrep: {
        css: css`
            margin-top: 10px;
        `,
    },
    cartLineNotesGridItem: {
        width: [6, 6, 6, 6, 6],
        css: css`
            padding: 0;
            button {
                margin-bottom: 0px;

                background-color: #f7f7f7;
                padding: 5px;
            }
            span {
                font-weight: 600;
            }
        `,
    },
    cartLineNotesAndCommentLinkGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 0;
            > div[class^="GridWrapper"] {
                background-color: #efefef;
                border-radius: 7px;
                > div[class^="GridOffset"] {
                    padding: 30px;
                    > div[class^="GridItemStyle"] {
                        padding: 8px !important;
                    }
                    input {
                        background: #fff;
                    }
                }
            }
        `,
    },

    cartLineNotes: {
        label: {
            css: css`
                button {
                    color: #a21010;
                    background: none !important;
                    border: none;
                    padding: 0;
                    font-size: 15px;
                    cursor: pointer;
                    font-weight: 600;
                    &:hover {
                        color: rgb(211, 21, 21);
                    }
                }
            `,
        },
    },

    LineNotesAndCommentGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            background-color: #f7f7f7;
            border-radius: 0px 0px 7px 7px;
            padding: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                            div[class^="GridItemStyle"] {
                                width: 100%;
                                button {
                                    border-radius: 0px 0px 7px 7px;
                                }
                            }
                        `,
                        css`
                            flex-direction: column;
                            div[class^="GridItemStyle"] {
                                width: 100%;
                                button {
                                    border-radius: 0px 0px 7px 7px;
                                }
                            }
                        `,
                        css`
                            flex-direction: column;
                            div[class^="GridItemStyle"] {
                                width: 100%;
                                button {
                                    border-radius: 0px 0px 7px 7px;
                                }
                            }
                        `,
                        null,
                    ],
                    "max",
                )}
            div[class^="GridItemStyle"] {
                span {
                    font-size: 14px;
                    font-weight: 600;
                    background-color: #f7f7f7;
                    padding: 4px;
                }
            }

            button {
                border-radius: 0px 0px 7px 0px;
                display: flex;
                justify-content: center;
            }
        `,
    },

    removeCartLineGridItem: {
        css: css`
            justify-content: center;
            height: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            position: absolute;
                            z-index: 5;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
        width: [1, 1, 1, 1, 1],
    },
    secondaryButton: {
        variant: "primary",
        css: css`
            width: 100%;
        `,
    },
    updateButton: {
        variant: "primary",
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            > span {
                background-color: transparent !important;
            }
        `,
    },
    removeCartLineIcon: { src: XCircle },
    binInformationsGridItem: {
        width: 12,
    },
    costCodeGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    updateButtonGridItem: {
        width: 12,
        css: css`
            display: flex;
            align-items: center;
            background-color: transparent;
            padding: 0px;
        `,
    },
    DiscontinuedGridItem: {
        width: 12,
        css: css`
            display: block;
            color: rgb(162, 16, 16);
            padding: 0;
            font-weight: 600;
            padding: 0 20px 20px;
        `,
    },
    contactUs: {
        css: css`
            > span[class^="TypographyStyle"] {
                text-decoration: underline;
            }
        `,
    },
    discontinuedWrapper: {
        css: css`
            background-color: #f0f0f0;
            margin: 0 -10px;
        `,
    },
};

const CartLineCardExpanded: FC<Props> = ({
    cart,
    cartLine,
    promotions,
    productSettings,
    showInventoryAvailability,
    showLineNotes,
    showImage = true,
    showProductTitle = true,
    showBrand = true,
    showPerUnitPrice = true,
    showPriceLabel = true,
    showAddToList = true,
    showProductNumber = true,
    updateCartLine,
    removeCartLine,
    extendedStyles,
    showRemoveAction,
    wishListSettings,
    setAddToListModalIsOpen,
    addToWishList,
    hideAddToList,
    showInvalidPriceMessage,
    showPricing,
    showVmiBinDetails,
    // location,
    // setLocation,
}) => {
    // const [location, setLocation] = React.useState(0);

    const toasterContext = useContext(ToasterContext);
    const [showNotesComment, setshowNotesComment] = useState(false);
    const lineNotesCommentClickHandler = () => {
        setshowNotesComment(!showNotesComment);
    };

    const [unitCostValue, setUnitCostValue] = useState(cartLine.properties.unitCost);
    const [commentValue, setCommentValue] = useState(cartLine.properties.comment);
    const [accountNumberValue, setAccountNumberValue] = useState(cartLine.properties.accountNumber);
    const [notesValue, setNotesValue] = useState(cartLine.notes);
    const [quantityValue, setQuantityValue] = useState(cartLine.qtyOrdered);
    const [costCodeValue, setcostCodeValue] = useState(cartLine.costCode);
    const [updateButton, setupdateButton] = useState(false);
    const [partNumberValue, setpartNumberValue] = useState(cartLine.properties.partNumber);

    useEffect(() => {
        setCommentValue(cartLine.properties.comment);
        setUnitCostValue(cartLine.properties.unitCost);
        setAccountNumberValue(cartLine.properties.accountNumber);
        setNotesValue(cartLine.notes);
        setQuantityValue(cartLine.qtyOrdered);
        setcostCodeValue(cartLine.costCode);
        setpartNumberValue(cartLine.properties.partNumber);
    }, [
        cartLine.properties.comment,
        cartLine.properties.unitCost,
        cartLine.properties.accountNumber,
        cartLine.notes,
        cartLine.qtyOrdered,
        cartLine.costCode,
        cartLine.properties.partNumber,
    ]);

    const updateCartLineData = () => {
        updateCartLine({
            cartLine: {
                ...cartLine,
                notes: notesValue,
                qtyOrdered: quantityValue,
                costCode: costCodeValue,
                properties: {
                    unitCost: unitCostValue,
                    comment: commentValue,
                    accountNumber: accountNumberValue,
                    partNumber: partNumberValue,
                },
            },
            shouldNotLoadFullCart: true,
            onSuccess: () => {
                setupdateButton(false);
                toasterContext.addToast({
                    body: translate("Cart Line Data Updated"),
                    messageType: "success",
                });
            },
        });
    };

    const currentMode = getCookie(NavigationModeCookieName);

    const qtyOrderedChangeHandler = (qtyOrdered: number) => {
        if (qtyOrdered !== cartLine.qtyOrdered) {
            if (qtyOrdered <= 0) {
                removeCartLine({ cartLineId: cartLine.id });
            } else {
                setQuantityValue(qtyOrdered);
                setupdateButton(true);
            }
        }
    };

    const UnitnotesChangeHandler = (productUnitcost: string) => {
        if (productUnitcost !== cartLine.properties.unitCost) {
            productUnitcost = productUnitcost.length !== 0 ? productUnitcost : "0";
            setUnitCostValue(productUnitcost);
            setupdateButton(true);
        }
    };

    const CommentChangeHandler = (productComment: string) => {
        if (productComment !== cartLine.properties.comment) {
            setCommentValue(productComment);
            setupdateButton(true);
        }
    };

    const AccountNumberChangeHandler = (productAccountNumber: string) => {
        if (productAccountNumber !== cartLine.properties.accountNumber) {
            setAccountNumberValue(productAccountNumber);
            setupdateButton(true);
        }
    };

    const notesChangeHandler = (notes: string) => {
        if (notes !== cartLine.notes) {
            setNotesValue(notes);
            setupdateButton(true);
        }
    };
    const CostCodeChangeHandler = (costCode: string) => {
        if (costCode !== cartLine.costCode) {
            setcostCodeValue(costCode);
            setupdateButton(true);
        }
    };
    const PartNumberChangeHandler = (partNumber: string) => {
        if (partNumber !== cartLine.properties.partNumber) {
            setpartNumberValue(partNumber);
            setupdateButton(true);
        }
    };
    const removeCartLineClickHandler = () => {
        if (!showRemoveAction) {
            return;
        }

        removeCartLine({ cartLineId: cartLine.id });
    };

    const addToListClickHandler = () => {
        if (!wishListSettings) {
            return;
        }

        const productInfo = {
            productId: cartLine.productId!,
            qtyOrdered: cartLine.qtyOrdered!,
            unitOfMeasure: cartLine.unitOfMeasure,
        };
        if (!wishListSettings.allowMultipleWishLists) {
            addToWishList({
                productInfos: [productInfo],
                onSuccess: () => {
                    toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                },
            });
            return;
        }

        setAddToListModalIsOpen({ modalIsOpen: true, productInfos: [productInfo] });
    };

    const saveScheduleHandler = (updatedSubscription: ProductSubscriptionDto) => {
        updateCartLine({
            cartLine: {
                ...cartLine,
                properties: {
                    productSubscription: JSON.stringify(updatedSubscription),
                },
            },
        });
    };

    const sumQtyPerUom = cart.cartLines!.reduce((sum, current) => {
        return current.productId === cartLine.productId
            ? sum + current.qtyPerBaseUnitOfMeasure * current.qtyOrdered!
            : sum;
    }, 0);

    const errorMessages: React.ReactNode[] = [];
    if (showInventoryAvailability && cartLine.hasInsufficientInventory && !isOutOfStock(cartLine)) {
        const tooManyRequestedMessage = siteMessage(
            "Cart_ToManyQtyRequested",
            cartLine.qtyOnHand.toLocaleString(),
            sumQtyPerUom.toLocaleString(),
        );
        errorMessages.push(tooManyRequestedMessage);
    }

    if (cartLine.isRestricted) {
        errorMessages.push(translate("Restricted product"));
    }

    if (!cartLine.isActive) {
        errorMessages.push(translate("Inactive product"));
    }

    if (cartLine.cantBuy) {
        errorMessages.push(translate("View-only product"));
    }

    useEffect(() => {
        if (cartLine.properties.accountNumber || cartLine.notes || cartLine.properties.comment) {
            const showNotesComment = true;
            setshowNotesComment(showNotesComment);
        }
    }, [cartLine.properties.accountNumber || cartLine.notes || cartLine.properties.comment]);

    const [styles] = React.useState(() => mergeToNew(cartLineCardExpandedStyles, extendedStyles));

    const [discontinued, setDiscontinued] = React.useState(false);

    React.useEffect(() => {
        if (cartLine.properties["productDiscontinued"]?.toLowerCase() === "true") {
            setDiscontinued(true);
        }
    }, []);

    return (
        <GridContainer
            {...styles.container}
            data-test-selector={`cartline_expanded_${cartLine.productId}_${cartLine.unitOfMeasure}`}
        >
            <GridItem {...styles.productImageGridItem}>
                {showImage && <ProductImage product={cartLine} extendedStyles={styles.productImage} />}
            </GridItem>
            <GridItem {...styles.cartLineInfoGridItem}>
                <GridContainer {...styles.cartLineInfoContainer}>
                    {/* <GridItem {...styles.productImageGridItem}>
                         <ProductImage product={cartLine} extendedStyles={styles.productImage} />
                    </GridItem> */}
                    <GridItem {...styles.productInfoGridItem}>
                        <GridContainer {...styles.productInfoContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {showBrand && cartLine.brand && (
                                    <ProductBrand brand={cartLine.brand} extendedStyles={styles.productBrand} />
                                )}
                                {showProductTitle && (
                                    <ProductDescription product={cartLine} extendedStyles={styles.productDescription} />
                                )}
                            </GridItem>
                            {!cartLine.isFixedConfiguration && cartLine.sectionOptions!.length > 0 && (
                                <GridItem {...styles.configurationGridItem}>
                                    {cartLine.sectionOptions!.map(option => (
                                        <Typography {...styles.configurationOptionText} key={option.sectionOptionId}>
                                            {`${option.sectionName}:${option.optionName}`}
                                        </Typography>
                                    ))}
                                </GridItem>
                            )}
                            <GridItem {...styles.productPartNumbersGridItem}>
                                <ProductPartNumbers
                                    productNumber={cartLine.erpNumber}
                                    customerProductNumber={cartLine.customerName}
                                    manufacturerItem={cartLine.manufacturerItem}
                                    extendedStyles={styles.productPartNumbers}
                                    showProductNumber={showProductNumber}
                                />
                            </GridItem>
                            {showVmiBinDetails && currentMode === "Vmi" && (
                                <GridItem {...styles.binInformationsGridItem}>
                                    <ProductBinNumbers
                                        locationId={cart.vmiLocationId}
                                        binId={cartLine.vmiBinId}
                                        isCondensed={false}
                                        extendedStyles={styles.productBinNumbers}
                                    />
                                </GridItem>
                            )}
                            <GridItem {...styles.quantityGridItem}>
                                <GridItem {...styles.qty}>
                                    <Typography as="span"> {translate("QTY")}</Typography>
                                </GridItem>
                                <GridItem {...styles.CartField}>
                                    <CartLineQuantity
                                        cart={cart}
                                        editable={true}
                                        onQtyOrderedChange={qtyOrderedChangeHandler}
                                        extendedStyles={styles.quantity}
                                    />
                                </GridItem>
                            </GridItem>
                            {!hideAddToList && (
                                <Link {...styles.addToListLinkWIthSalesrep} onClick={addToListClickHandler}>
                                    {translate("Add to List")}
                                </Link>
                            )}

                            {cartLine.isSubscription && cartLine.productSubscription && (
                                <ProductDeliveryScheduleButton
                                    subscription={
                                        cartLine.properties.productSubscription
                                            ? JSON.parse(cartLine.properties.productSubscription)
                                            : cartLine.productSubscription
                                    }
                                    disabled={
                                        !cart.canModifyOrder ||
                                        cartLine.isPromotionItem ||
                                        !cartLine.qtyOrdered ||
                                        cartLine.qtyOrdered <= 0
                                    }
                                    onSave={saveScheduleHandler}
                                    extendedStyles={styles.deliveryScheduleButton}
                                />
                            )}

                            {errorMessages.length > 0 && (
                                <GridItem {...styles.cartLineErrorMessageGridItem}>
                                    {errorMessages.map((message, index) => (
                                        <Typography
                                            {...styles.cartLineErrorMessageText}
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={index}
                                            data-test-selector="cartline_errorMessage"
                                        >
                                            {message}
                                        </Typography>
                                    ))}
                                </GridItem>
                            )}
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.productPriceAndAvailabilityGridItem}>
                        {promotions.map(promotion => (
                            <Typography {...styles.promotionNameText} key={promotion.id}>
                                {promotion.name}
                            </Typography>
                        ))}
                        {showInventoryAvailability && !cartLine.quoteRequired && (
                            <ProductAvailability
                                productId={cartLine.productId!}
                                availability={cartLine.availability!}
                                unitOfMeasure={cartLine.unitOfMeasure}
                                trackInventory={cartLine.trackInventory}
                                extendedStyles={styles.productAvailability}
                            />
                        )}
                        {!cart.cartNotPriced && (
                            <ProductPrice
                                product={cartLine}
                                currencySymbol={cart.currencySymbol}
                                showSavings={true}
                                showSavingsAmount={productSettings.showSavingsAmount}
                                showSavingsPercent={productSettings.showSavingsPercent}
                                showInvalidPriceMessage={showInvalidPriceMessage}
                                extendedStyles={styles.productPrice}
                            />
                        )}
                        <>
                            {" "}
                            {cart.isSalesperson && (
                                <GridItem {...styles.UnitNetPriceGridItem}>
                                    <GridItem {...styles.unitNotesHeading}>
                                        <Typography as="span"> {translate("Unit Cost")}</Typography>
                                    </GridItem>
                                    <GridItem {...styles.UnitNetPriceInputGrid}>
                                        <CartUnitsNotes
                                            cart={cart}
                                            editable={true}
                                            onNotesChange={UnitnotesChangeHandler}
                                            extendedStyles={styles.CartUnitsNotes}
                                        />
                                    </GridItem>
                                </GridItem>
                            )}
                            <GridItem {...styles.CartCostCodeGridItem}>
                                <CartCostCode
                                    cart={cart}
                                    cartLine={cartLine}
                                    editable={true}
                                    onCostCodesChange={CostCodeChangeHandler}
                                    extendedStyles={styles.cartCostCode}
                                />
                            </GridItem>
                            <GridItem {...styles.CartCostCodeGridItem}>
                                <CartAlternatePartNumber
                                    cart={cart}
                                    editable={true}
                                    onPartNumberChange={PartNumberChangeHandler}
                                    extendedStyles={styles.CartPartNumber}
                                />
                            </GridItem>
                        </>
                    </GridItem>
                    {discontinued && (
                        <StyledWrapper {...styles.discontinuedWrapper}>
                            <GridItem {...styles.DiscontinuedGridItem} data-test-selector="invoiceHistory_invoiceTotal">
                                <Typography {...styles.discontinuedMsg}>
                                    {translate(" This item is now discontinued. Please")}
                                </Typography>
                                &nbsp;
                                <Link {...styles.contactUs} href="/ContactUs">
                                    {translate("Contact us")}
                                </Link>{" "}
                                &nbsp;
                                <Typography {...styles.discontinuedMsg}>
                                    {translate("for more information about replacement items. ")}
                                </Typography>
                                <Typography {...styles.discontinuedMsg}>
                                    {translate("Also, please remove it from cart to proceed further.")}
                                </Typography>
                            </GridItem>
                        </StyledWrapper>
                    )}
                </GridContainer>
            </GridItem>
            <GridItem {...styles.removeCartLineGridItem}>
                {showRemoveAction && (
                    <Clickable onClick={removeCartLineClickHandler} data-test-selector="cartline_removeLine">
                        <VisuallyHidden>{translate("Remove item")}</VisuallyHidden>

                        <IconMemo {...styles.removeCartLineIcon} />
                    </Clickable>
                )}
            </GridItem>
            <GridItem {...styles.LineNotesAndCommentGridItem}>
                {/* <GridItem {...styles.LineNotesAndCommentGridItem}> */}
                <GridItem {...styles.cartLineNotesAndCommentLinkGridItem}>
                    <Typography as="span">
                        <Link
                            {...styles.toggleLink}
                            onClick={lineNotesCommentClickHandler}
                            data-test-selector="cartunit_notesShowHideButton"
                        >
                            {translate("Line Notes/Comment/Account Number")}
                        </Link>
                    </Typography>
                </GridItem>
                {updateButton && (
                    <GridItem {...styles.updateButtonGridItem}>
                        <Button {...styles.updateButton} onClick={updateCartLineData}>
                            {translate("Update Cart Line Item")}
                        </Button>
                    </GridItem>
                )}
            </GridItem>
            <GridItem {...styles.cartLineNotesAndCommentLinkGridItem}>
                {showNotesComment && showLineNotes && cart.properties["isPunchout"] === undefined && (
                    <GridContainer>
                        <GridItem {...styles.cartLineNotesGridItem}>
                            <CartLineNotes
                                cart={cart}
                                editable={true}
                                onNotesChange={notesChangeHandler}
                                extendedStyles={styles.cartLineNotes}
                            />
                        </GridItem>
                        <GridItem {...styles.cartLineNotesGridItem}>
                            <CartLineComment
                                cart={cart}
                                editable={true}
                                onCommentChange={CommentChangeHandler}
                                extendedStyles={styles.CartLineComment}
                            />
                        </GridItem>
                        <GridItem {...styles.cartLineNotesGridItem}>
                            <CartLineAccountNumber
                                cart={cart}
                                editable={true}
                                onAccountNumberChange={AccountNumberChangeHandler}
                                extendedStyles={styles.CartLineAccountNumber}
                            />
                        </GridItem>
                    </GridContainer>
                )}
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withCartLine(CartLineCardExpanded));
